import React, { useContext, useState, useMemo, useEffect, useRef } from 'react'
import './index.scss'
import { RESOURCE_MANAGER } from '@/config'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import FUIcon from '../FUIcon'
import { IHistory } from '@/packages/sdk/fu_resource_manager/RendererRecorder'

const AvatarRecorder = (props) => {
    const { scheduleUpdateAvatar, avatar, avatarConfig } = useContext(AvatarContext)
    const [history, setHisory] = useState<IHistory[]>([])
    const [pointer, setPointer] = useState<number>(-1)
    const originAvatarConfig = useRef<any>()
    const { style } = props

    const checkRecorderStatus = (history: IHistory[], pointer: number) => {
        setHisory(history)
        setPointer(pointer)
    }

    useEffect(() => {
        const eventId = RESOURCE_MANAGER.recorder.sub(checkRecorderStatus)
        return () => {
            RESOURCE_MANAGER.recorder.unsub(eventId)
        }
    }, [])

    useEffect(() => {
        if (avatar) {
            RESOURCE_MANAGER.recorder.reset()
            originAvatarConfig.current = JSON.parse(avatar.getJson())
        }
    }, [avatar])

    const backforward = () => {
        const { handler, oldValue } = RESOURCE_MANAGER.recorder.backforward()
        handler(oldValue)
    }
    const stepforward = () => {
        const { handler, newValue } = RESOURCE_MANAGER.recorder.stepforward()
        handler(newValue)
    }

    const resetAvatar = () => {
        RESOURCE_MANAGER.recorder.reset()
        scheduleUpdateAvatar({
            ...avatarConfig,
            data: originAvatarConfig.current
        })
    }

    return (
        <div
            className="recorder-manager"
            style={style}
        >
            <div className='recorder-handler'>
                <FUIcon
                    // className={disabled ? 'disabled' : ''}
                    className={history.length === 0 ? 'disabled' : ''}
                    onClick={resetAvatar}
                    name='slices/icon_clear_nor.png'
                />
            </div>
            <div className='recorder-handler'>
                <FUIcon
                    className={history.length === 0 || pointer === -1 ? 'disabled' : ''}
                    onClick={history.length === 0 || pointer === -1 ? () => { } : backforward}
                    name='slices/icon_withdraw_nor.png'
                />
                <FUIcon
                    className={history.length === 0 || pointer === history.length - 1 ? 'disabled' : ''}
                    onClick={history.length === 0 || pointer === history.length - 1 ? () => { } : stepforward}
                    name='slices/icon_forword_nor.png'
                />
            </div>
        </div>
    )
}

export default AvatarRecorder
